import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import GetAvgRating from "../../../utils/avgRating";
import RatingStars from "../../common/RatingStars";

function Course_Card({ course }) {
  const [avgReviewCount, setAvgReviewCount] = useState(0);

  useEffect(() => {
    setAvgReviewCount(GetAvgRating(course.ratingAndReviews));
  }, [course]);

  return (
    <Link
      to={`/courses/${course._id}`}
      className="flex h-full flex-col overflow-hidden rounded-2xl border border-richblack-700 bg-richblack-800 transition-[border-color,box-shadow] duration-200 hover:border-richblack-500 hover:shadow-[0_6px_28px_rgba(0,0,8,0.55)]"
    >
      {/* Fixed-height thumbnail - plain <img> so h-full works without wrapper issues */}
      <div className="h-44 w-full flex-shrink-0 overflow-hidden bg-richblack-700">
        <img
          src={course?.thumbnail}
          alt={course?.courseName}
          loading="lazy"
          className="h-full w-full object-cover"
        />
      </div>

      {/* Card body */}
      <div className="flex flex-1 flex-col gap-2 p-4">
        {/* Title: line-clamp keeps max 2 lines; min-h reserves space so
            single-line titles don't shift the price row */}
        <p className="line-clamp-2 min-h-[2.5rem] text-sm font-semibold leading-snug text-richblack-5">
          {course?.courseName}
        </p>

        <p className="text-xs text-richblack-400">
          {course?.instructor?.firstName} {course?.instructor?.lastName}
        </p>

        <div className="flex items-center gap-1.5">
          <span className="text-xs font-bold text-yellow-50">
            {avgReviewCount || 0}
          </span>
          <RatingStars Review_Count={avgReviewCount} Star_Size={12} />
          <span className="text-xs text-richblack-500">
            ({course?.ratingAndReviews?.length ?? 0})
          </span>
        </div>

        {/* Price pinned to bottom */}
        <p className="mt-auto pt-3 text-sm font-bold text-richblack-5">
          ₹{course?.price?.toLocaleString("en-IN")}
          <span className="font-normal text-richblack-400"> /-</span>
        </p>
      </div>
    </Link>
  );
}

export default Course_Card;
